/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dizzy_Long_Swallow_SwimInputs */

const fr_dizzy_long_swallow_swim = /** @type {(inputs: Dizzy_Long_Swallow_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez changer votre mot de passe ici.`)
};

/**

* @param {Dizzy_Long_Swallow_SwimInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dizzy_long_swallow_swim = /** @type {((inputs?: Dizzy_Long_Swallow_SwimInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dizzy_Long_Swallow_SwimInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dizzy_long_swallow_swim(inputs)
});